const mapSection = $('#map-section');
const mapFinder = mapSection.find('.map-finder');
const mapCardsList = mapSection.find('.distributors-list-overflow');
const mapCards = mapSection.find('.distributor-card');
const mapContainer = mapSection.find('.distributors-map');
const dropdownTags = mapSection.find('.map-dropdown-item');
const searchInputParent = mapSection.find('.map-search-parent');
const searchInput = mapSection.find('.map-search-input');

let map;
let popup;
let activePointID;
let lastActiveCard = mapCards.eq(0);
let lastActiveTag;
const tagsTLs = [];

const searchData = {
  input: '',
  countries: [],
};

const cardsListLenis = new Lenis({
  wrapper: mapCardsList.get(0),
  autoRaf: true,
});

const pointsGeoJSON = {
  type: 'FeatureCollection',
  features: distributorsObjs.map((item) => {
    item.pointCard = $(`#distributor-card-${item.index}`);
    return {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [item.x, item.y],
      },
      properties: {
        index: item.index,
        title: item.title,
        description: item.description,
        mapLink: item.mapLink,
        websiteLink: item.websiteLink,
      },
    };
  }),
};

const distributorsByIndex = new Map(distributorsObjs.map((item) => [item.index, item]));

if (distributorsObjs.length > 0) {
  lastActiveCard = distributorsObjs[0].pointCard;
}

const changeChecked = (dropdownTag) => {
  const dropdownTagParent = dropdownTag.closest('.map-dropdown-item-parent');
  const checkedCountContainer = dropdownTagParent.find('.map-dropdown-item-checked-count');
  const checkedInputs = dropdownTagParent.find('.topic-input:checked');
  if (checkedCountContainer) {
    if (checkedInputs.length == 0) {
      checkedCountContainer.hide();
    } else {
      checkedCountContainer.show();
    }
    checkedCountContainer.html(`&#x${2460 + checkedInputs.length - 1}`);
  }
};

const tagCloseIconAnimation = (closeIcon) => {
  const closeIconTL = gsap.timeline({ paused: true });
  closeIconTL.add(
    gsap.fromTo(
      closeIcon,
      {
        x: '3.125vw',
      },
      {
        x: 0,
        duration: 0.6,
        ease: 'tagInEasing',
      }
    ),
    0
  );
  closeIconTL.add(
    gsap.fromTo(
      closeIcon,
      {
        rotate: 0,
      },
      {
        rotate: -45,
        duration: 0.36,
        ease: 'tagInEasing',
      }
    ),
    0.14
  );
  closeIconTL.add(
    gsap.fromTo(
      closeIcon,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.36,
        ease: 'opacityInEasing',
      }
    ),
    0.24
  );

  return closeIconTL;
};

const tagContentAnimation = (content) => {
  CustomEase.create('tagContentEasing', '0.2, 0, 0.2, 1');
  const contentTL = gsap.timeline({ paused: true });
  contentTL.add(
    gsap.fromTo(
      content,
      {
        y: '-1.875vw',
      },
      {
        y: 0,
        duration: 0.67,
        ease: 'tagContentEasing',
      }
    ),
    0
  );
  contentTL.add(
    gsap.fromTo(
      content,
      {
        opacity: 0,
      },
      {
        opacity: 1,
        duration: 0.67,
        ease: 'opacityInEasing',
      }
    ),
    0
  );

  return contentTL;
};

const tagLineAniamtion = (line) => {
  const lineTL = gsap.timeline({ paused: true });
  lineTL.add(
    gsap.fromTo(
      line,
      {
        transformOrigin: 'center center',
        scaleX: 0,
      },
      {
        scaleX: 1,
        duration: 0.67,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  return lineTL;
};

const toggleTag = (index) => {
  const currentTag = dropdownTags.eq(index);
  const tagOverflow = currentTag.closest('.map-dropdown-overflow');
  const tagContent = currentTag.find('.map-dropdown-item-content');
  const dropdownClosedTopper = currentTag.find('.map-dropdown-item-topper-closed');
  const dropdownLine = currentTag.find('.map-dropdown-item-topper-line');
  const dropdownOpenIcon = currentTag.find('.map-dropdown-item-icon');
  const dropdownCloseIcon = currentTag.find('.map-dropdown-close');
  const fromWidth = pxToVw(dropdownClosedTopper.outerWidth());
  const fromHeight = pxToVw(dropdownClosedTopper.outerHeight());
  const toWidth = pxToVw(currentTag.outerWidth());
  const toHeight = pxToVw(currentTag.outerHeight());
  const paddingFrom = isDesktop() ? `0.375vw 0.625vw` : isTablet() ? `0.781vw 1.302vw` : `1.389vw 2.778vw`;
  const paddingTo = isDesktop()
    ? `0.625vw 0.625vw 1.563vw 0.625vw`
    : isTablet()
    ? `1.302vw 1.302vw 2.604vw 1.302vw`
    : `2.778vw 2.778vw 5.556vw 2.778vw`;
  const toggleTagTL = gsap.timeline({
    paused: true,
    onStart: () => {
      gsap.set(dropdownCloseIcon, { display: 'block' });
    },
    onComplete: () => {},
    onReverseComplete: () => {
      gsap.set(dropdownCloseIcon, { display: 'none' });
    },
  });
  toggleTagTL.add(
    gsap.fromTo(
      tagOverflow,
      {
        width: `${fromWidth}vw`,
        height: `${fromHeight}vw`,
        padding: paddingFrom,
      },
      {
        width: `${toWidth}vw`,
        height: `${toHeight}vw`,
        padding: paddingTo,
        duration: 0.67,
        ease: 'pageInEasing',
      }
    ),
    0
  );

  toggleTagTL.add(tagCloseIconAnimation(dropdownCloseIcon).play(), 0.07);
  toggleTagTL.add(tagContentAnimation(tagContent).play(), 0);
  toggleTagTL.add(tagLineAniamtion(dropdownLine).play(), 0);
  toggleTagTL.add(
    gsap.fromTo(
      dropdownOpenIcon,
      {
        opacity: 1,
      },
      {
        opacity: 0,
        duration: 0.27,
        ease: 'opacityInEasing',
      }
    ),
    0
  );
  if (currentTag.attr('id') == 'date') {
    toggleTagTL.add(tagDateAnimtion(currentTag).play(), 0);
  }
  return toggleTagTL;
};

const addMapIn = () => {
  const finderChilds = mapFinder.children();
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const sectionTopperInTL = gsap.timeline({ paused: true });
  const sectionInTL = gsap.timeline({ paused: true });

  if (isDesktop()) {
    sectionTopperInTL.add(
      animateSectionTopperIn({
        sectionParent: mapSection,
        gradientConfig: gradientConfig,
      }).play(),
      0
    );
    mapCards.each(function (index) {
      sectionInTL.add(elementInAnimationYWOpacity($(this), '6.25vw', 0, 1, 1, 0.83, 0.17).play(), 0.1 + 0.06 * index);
    });
    sectionInTL.add(elementInAnimationYWOpacity(mapContainer, '7.5vw', 0, 1, 1, 0.83, 0.17).play(), 0.2);
    mapContainer;
  }

  return [sectionTopperInTL, sectionInTL];
};

function bindMapEvents() {
  map.on('mouseenter', 'inner-circle', () => {
    map.getCanvas().style.cursor = 'pointer';
  });

  map.on('mouseleave', 'inner-circle', () => {
    map.getCanvas().style.cursor = '';
  });

  map.on('click', 'inner-circle', (e) => {
    const data = distributorsByIndex.get(Number(e.features[0].properties.index));
    if (data) {
      flyToPoint(data, true);
    }
  });

  distributorsObjs.forEach((item) => {
    item.pointCard.on('click', () => flyToPoint(item, false));
  });
}

function showPopup(data) {
  const websiteLink = typeof data.websiteLink === 'string' ? data.websiteLink.trim() : '';
  const websiteButton = websiteLink
    ? `<a class="map-popup-link font-secondary-text" href="${websiteLink}" target="_blank">Website</a>`
    : '';

  popup
    .setLngLat([data.x, data.y])
    .setHTML(`
      <h4 class="map-popup-title font-descriptor-bold">${data.title}</h4>
      <p class="map-popup-text font-secondary-text">${data.description}</p>
      ${websiteButton}
    `)
    .addTo(map);
}

function toggleActiveCard(toCard, byPoint) {
  gsap.to(lastActiveCard, { opacity: 1, duration: 1.3 });
  gsap.to(toCard, { opacity: 1, duration: 1.3 });

  if (byPoint) {
    cardsListLenis.scrollTo(toCard.get(0), { duration: 1.33 });
  }

  lastActiveCard = toCard;
}

function flyToPoint(data, byPoint = false) {
  if (activePointID !== data.index) {
    activePointID = data.index;
    toggleActiveCard(data.pointCard, byPoint);

    let prevZoom = map.getZoom();
    let shown = false;

    const zoomHandler = () => {
      const z = map.getZoom();
      if (!shown && z > 8 && z > prevZoom) {
        shown = true;
        showPopup(data);
        map.off('zoom', zoomHandler);
      }
      prevZoom = z;
    };

    map.on('zoom', zoomHandler);

    map.flyTo({
      center: [data.x, data.y],
      zoom: 12,
      minZoom: 5,
      duration: 4000,
      essential: true,
      easing: (t) => t,
    });
  } else {
    showPopup(data);
  }
}
function updatePointsVisibility(indexes) {
  map.setFilter('inner-circle', ['in', ['get', 'index'], ['literal', indexes]]);
  map.setFilter('outer-circle', ['in', ['get', 'index'], ['literal', indexes]]);
}

function sortResults(updateState = false) {
  let count = 0;
  const visible = [];

  mapCards.each(function (index) {
    const values = Object.values(this.dataset).map(v => v.toLowerCase());
    const inputMatch = values.some(v => v.includes(searchData.input.toLowerCase()));
    const countryMatch =
      !searchData.countries.length ||
      searchData.countries.some(c => values.some(v => v.includes(c.toLowerCase())));

    if (inputMatch && countryMatch) {
      count++;
      visible.push(index);
      if (updateState) $(this).css('display', 'flex');
    } else {
      if (updateState) $(this).css('display', 'none');
    }
  });

  if (updateState) updatePointsVisibility(visible);
  return count;
}

function initDropdowns() {
  dropdownTags.each(function (index) {
    const dropdownTag = $(this);
    const showResultsBtnCount = dropdownTag.find('.map-dropdown-resul-count');
    const tagCheckboxes = dropdownTag.find('.topic-input');
    const closeBtn = dropdownTag.find('.map-dropdown-close');
    const showResults = dropdownTag.find('.map-dropdown-item-show');
    const clearAll = dropdownTag.find('.map-dropdown-item-clear');
    const tagList = dropdownTag.find('.map-dropdown-item-topics-list');

    new Lenis({ wrapper: tagList.get(0), autoRaf: true });

    showResultsBtnCount.text(sortResults());
    tagsTLs.push(toggleTag(index));

    dropdownTag.on('click', (e) => {
      e.stopPropagation();
      tagsTLs[index].play();
      lastActiveTag = index;
    });

    closeBtn.on('click', (e) => {
      e.stopPropagation();
      tagsTLs[lastActiveTag].reverse();
      lastActiveTag = undefined;
      sortResults(true);
      changeChecked(dropdownTag);
    });

    showResults.on('click', (e) => {
      e.stopPropagation();
      tagsTLs[lastActiveTag].reverse();
      lastActiveTag = undefined;
      sortResults(true);
      changeChecked(dropdownTag);
    });

    clearAll.on('click', (e) => {
      e.stopPropagation();
      tagCheckboxes.prop('checked', false);
      searchData.countries = [];
      showResultsBtnCount.text(sortResults());
    });

    tagCheckboxes.on('change', function () {
      this.checked
        ? searchData.countries.push(this.value)
        : (searchData.countries = searchData.countries.filter(c => c !== this.value));
      showResultsBtnCount.text(sortResults());
    });
  });
}

function initSearch() {
  searchInput.on('input', function () {
    searchData.input = $(this).val();
    sortResults(true);
  });

  searchInput.on('focus', () =>
    gsap.to(searchInputParent, { borderColor: 'rgba(2,1,20,.4)', duration: 0.67 })
  );

  searchInput.on('blur', () =>
    gsap.to(searchInputParent, { borderColor: 'transparent', duration: 0.67 })
  );
}

$(window).on('load', () => {
  /* ---- SECTION IN ---- */
  const [mapTopperTL, mapTL] = addMapIn();

  ScrollTrigger.create({
    trigger: mapSection,
    start: 'top top+=120%',
    end: 'top top',
    once: true,
    onUpdate: (self) => mapTopperTL.progress(self.progress),
  });

  ScrollTrigger.create({
    trigger: mapSection,
    start: 'top top+=60%',
    end: 'bottom bottom',
    once: true,
    onEnter: () => {
      mapTL.play();
      if (distributorsObjs.length > 0) {
        gsap.delayedCall(0.3, () => flyToPoint(distributorsObjs[0]));
      }
    },
  });

  /* ---- MAP ---- */
  map = new maplibregl.Map({
    container: 'map',
    style: 'https://api.protomaps.com/styles/v5/white/en.json?key=9ba88f403a109f51',
    center: [0, 0],
    zoom: 1.2,
    cooperativeGestures: true,
  });

  map.on('load', () => {
    map.setRenderWorldCopies(false);

    $(map._container)
      .find('.maplibregl-desktop-message')
      .text('Use Ctrl + scroll to zoom the map');

    map.addSource('distributors', {
      type: 'geojson',
      data: pointsGeoJSON,
    });

    const mapPointsConfigs = {
      outterCircleRadius: isDesktop() ? 12 : isTablet() ? 13 : 7,
      innerCircleRadius: isDesktop() ? 6 : isTablet() ? 6 : 3,
    };

    map.addLayer({
      id: 'outer-circle',
      type: 'circle',
      source: 'distributors',
      paint: {
        'circle-radius': mapPointsConfigs.outterCircleRadius,
        'circle-color': '#020114',
        'circle-opacity': 0.3,
      },
    });

    map.addLayer({
      id: 'inner-circle',
      type: 'circle',
      source: 'distributors',
      paint: {
        'circle-radius': mapPointsConfigs.innerCircleRadius,
        'circle-color': '#081B48',
      },
    });

    popup = new maplibregl.Popup({
      className: 'point-popup',
      anchor: 'bottom',
      offset: isDesktop() ? [0, -35] : [0, -18],
    });

    bindMapEvents();
  });

  initDropdowns();
  initSearch();
});
